class Project {
  constructor({
    id = '',
    id_project = 0,
    name = '',
    description = '',
    country_code = '',
    work_code = '',
    requester = '',
    normative_name = '',
    normative_data = '',
    project_image,
    ute_image,
    timezone,
    concrete_providers = [],
    laboratory_providers = [],
  }) {
    this.id = id;
    this.id_project = id_project;
    this.name = name;
    this.description = description;
    this.country_code = country_code;
    this.work_code = work_code;
    this.requester = requester;
    this.normative_name = normative_name;
    this.normative_data = normative_data;
    this.project_image = project_image;
    this.ute_image = ute_image;
    this.timezone = timezone;
    this.concrete_providers = concrete_providers;
    this.laboratory_providers = laboratory_providers;
  }
}

export default Project;
